/* eslint-disable */
import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";

declare var $: any;
declare function clickToAddEvent(): void;
declare function resizegridOnWindowResize(): void;
declare function saveExtraPanelSetting(): any;

import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Subscription } from "rxjs";
import { AppService } from "src/app/app.service";
import { PageParams } from "src/app/store/models/navigation-settings.model";
import { delay } from "rxjs/operators";
import {
  VAIconRegistryService,
  arrowCircleLeft,
  arrowCircleRight,
} from "@va/core-library/icons";

@Component({
  selector: "app-mex-grid-page",
  templateUrl: "./mex-grid-page.component.html",
  styleUrls: ["./mex-grid-page.component.scss"],
  host: { class: "mex-grid-component" },
  encapsulation: ViewEncapsulation.None,
})
export class MexGridPageComponent implements OnInit, OnDestroy {
  globalSettingsSubscription: Subscription;
  constructor(
    private store: Store<AppState>,
    private titleService: Title,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([arrowCircleLeft, arrowCircleRight]);
  }
  data = [];
  disabledSidebar = false;
  isRightsideBarCollapsed = true;
  showRightSidebar = true;
  pageParamsSubcription: Subscription;
  pageNavParams: PageParams;
  rightSidebarActivePanel;

  ngOnInit() {
    window.addEventListener(
      "OpenRightPanelPeriod",
      this.openPeriodPanelInRightSidebar.bind(this),
    );

    this.loadGlobalsFromQueryParams();
    this.store
      .select(stateGetter("rightPanel", "isCollapsed"))
      .subscribe((isCollapsed) => {
        this.isRightsideBarCollapsed = isCollapsed;
        // found this event being dispatched in lefSiderChanged on appComponent
        // this enables the arrow scroll buttos on grid tabs when space is less than required
        setTimeout(function () {
          const resizeEvt = new Event("resize");
          window.dispatchEvent(resizeEvt);
        }, 300);
      });
    this.data = [
      {
        code: "FI-SW-01",
        name: "Koi",
        unitcost: 10.0,
        status: "P",
        listprice: 36.5,
        attr: "Large",
        itemid: "EST-1",
      },
      {
        code: "K9-DL-01",
        name: "Dalmation",
        unitcost: 12.0,
        status: "P",
        listprice: 18.5,
        attr: "Spotted Adult Female",
        itemid: "EST-10",
      },
      {
        code: "RP-SN-01",
        name: "Rattlesnake",
        unitcost: 12.0,
        status: "P",
        listprice: 38.5,
        attr: "Venomless",
        itemid: "EST-11",
      },
      {
        code: "RP-SN-01",
        name: "Rattlesnake",
        unitcost: 12.0,
        status: "P",
        listprice: 26.5,
        attr: "Rattleless",
        itemid: "EST-12",
      },
      {
        code: "RP-LI-02",
        name: "Iguana",
        unitcost: 12.0,
        status: "P",
        listprice: 35.5,
        attr: "Green Adult",
        itemid: "EST-13",
      },
      {
        code: "FL-DSH-01",
        name: "Manx",
        unitcost: 12.0,
        status: "P",
        listprice: 158.5,
        attr: "Tailless",
        itemid: "EST-14",
      },
      {
        code: "FL-DSH-01",
        name: "Manx",
        unitcost: 12.0,
        status: "P",
        listprice: 83.5,
        attr: "With tail",
        itemid: "EST-15",
      },
      {
        code: "FL-DLH-02",
        name: "Persian",
        unitcost: 12.0,
        status: "P",
        listprice: 23.5,
        attr: "Adult Female",
        itemid: "EST-16",
      },
      {
        code: "FL-DLH-02",
        name: "Persian",
        unitcost: 12.0,
        status: "P",
        listprice: 89.5,
        attr: "Adult Male",
        itemid: "EST-17",
      },
      {
        code: "AV-CB-01",
        name: "Amazon Parrot",
        unitcost: 92.0,
        status: "P",
        listprice: 63.5,
        attr: "Adult Male",
        itemid: "EST-18",
      },
    ];
    // $("#test").attr("try", "try");
    // $("#test").datagrid({
    //   idField: "name",
    //   height: "450px",
    //   width: "600px",
    //   columns: [
    //     [
    //       { field: "code", title: "Code", width: 100 },
    //       { field: "name", title: "Name", width: 100 },
    //       { field: "listprice", title: "Price", width: 100 }
    //     ]
    //   ]
    // });
    // $("#test").datagrid("loadData", this.data);

    // setTimeout(function() {
    //   $(".datagrid-header-inner").css("background-color", "red");
    // }, 5000);

    this.pageParamsSubcription = this.store
      .select(stateGetter("navigationSettings", "pageParams"))
      .pipe(delay(2000))
      .subscribe((pageNavParams) => {
        const { cut, ticker, pg, source } = pageNavParams;
        this.pageNavParams = pageNavParams;
        //In case of SAR view, display the Source in the Title as well
        const mexTitle =
          source === undefined
            ? `Model Explorer ${ticker} - ${cut} - ${pg}`
            : `Model Explorer ${ticker} - ${cut} - ${pg} - ${source}`;
        this.titleService.setTitle(mexTitle);
      });
    this.globalSettingsSubscription = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        if (data && window.hasDsmAccess !== null) {
          window.hasDsmAccess = data.hasDsmAccess;

          window.dispatchEvent(new Event("dsmAccessSet"));
        }
      });
  }

  ngOnDestroy() {
    if (this.pageParamsSubcription) {
      this.pageParamsSubcription.unsubscribe();
    }
    if (this.globalSettingsSubscription) {
      this.globalSettingsSubscription.unsubscribe();
    }
  }

  rightSiderCollapseChanged(event) {
    setTimeout(() => {
      saveExtraPanelSetting();
      resizegridOnWindowResize();
      // found this event being dispatched in lefSiderChanged on appComponent
      // this enables the arrow scroll buttons on grid tabs when space is less than required
      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 300);
    }, 100);

    this.logRpExpansionState(event);
  }

  openPeriodPanelInRightSidebar() {
    this.showRightSidebar = true;
    this.isRightsideBarCollapsed = false;
    this.rightSidebarActivePanel = "periods";
    this.rightSiderCollapseChanged(true);
    const toggleRightSidebar = new CustomEvent("ToggleRightSidebar", {
      detail: { isCollapsed: event },
    });
    window.dispatchEvent(toggleRightSidebar);
  }

  logRpExpansionState(isCollapsed) {
    this.appService.logUserAction(
      "RIGHT_PANEL_" + (isCollapsed ? "COLLAPSE" : "EXPAND"),
      this.pageNavParams.ticker,
      this.pageNavParams.cut,
      "RIGHT_PANEL_" + (isCollapsed ? "COLLAPSE" : "EXPAND"),
      {
        company: this.pageNavParams.ticker,
      },
      "" || this.pageNavParams.source,
      "RIGHT_PANEL_CLICK",
    );
  }

  loadGlobalsFromQueryParams() {
    var url = window.location.toString().replace("%20", " ");
    var data = url.split("?");

    if ($.QueryString("pinnedPanel") != null) {
      window.pinnedPanel = $.QueryString("pinnedPanel");
    }

    if ($.QueryString("basis") != null) {
      window.gBasis = decodeURIComponent($.QueryString("basis"));
    }
    if ($.QueryString("depth") != null) {
      window.gAdjust =
        window.cut == "STD"
          ? "implied"
          : decodeURIComponent($.QueryString("depth"));
    }
    if ($.QueryString("revision") != null) {
      window.gRevision = decodeURIComponent($.QueryString("revision"));
    }
    if ($.QueryString("variant") != null) {
      window.gVariant = decodeURIComponent($.QueryString("variant"));
    }
    if ($.QueryString("scenario") != null) {
      window.gScenario = decodeURIComponent($.QueryString("scenario"));
    }
    if (
      $.QueryString("edit_scenario") != null &&
      $.QueryString("edit_scenario") == "true"
    ) {
      window.editScenarioMode = true;
      window.customScenarioMode = true;
      window.customScenarioName = window.gScenario;
    }
    if ($.QueryString("edit") != null) {
      if ($.QueryString("edit") == "true") window.compositeEdit = true;
    }
    if ($.QueryString("dpid") != null) {
      window.highlightDp = decodeURIComponent($.QueryString("dpid"));
    }
    if ($.QueryString("period") != null) {
      window.highlightPeriod = decodeURIComponent($.QueryString("period"));
    }
    if ($.QueryString("load_revision") != null) {
      window.load_revision = decodeURIComponent($.QueryString("load_revision"));
    }
    if ($.QueryString("period_revision") != null) {
      window.period_revision = decodeURIComponent(
        $.QueryString("period_revision"),
      );
    }
    if ($.QueryString("expand_consensus") != null) {
      window.expand_consensus =
        decodeURIComponent($.QueryString("expand_consensus")) == "true"
          ? true
          : false;
    }

    clickToAddEvent();
  }

  handleRightsidebarPanelChange(value) {
    this.rightSidebarActivePanel = value;
    if (!value) {
      const toggleRightSidebar = new CustomEvent("ToggleRightSidebar", {
        detail: { isCollapsed: !value },
      });
      window.dispatchEvent(toggleRightSidebar);
    }
  }
}
